export enum RutaCatalogoEnum {
    ROLES = "catRoles",
    ESTADOS = "catEstados",
    EMPRESAS = "catEmpresas",
    SECCIONES = "catTipoSeccion",
    CARPETAS = "catTipoCarpeta",
    COLORES = "catColores",
    PRIORIDAD = "catTipoPrioridad",
    ORIGEN_RECURSOS = "catTipoOrigenRecursos",
    DIRECCIONES_ADJUNTAS = "catDireccionAdjunta",
    TIPOS_OBRAS = "catTipoObra",
    TIPOS_LEVANTAMIENTOS = "catTipoLevantamiento",
    CORREDORES = "catCorredores",
    ESTATUS_VALIDACIONES_OBRA = "catEstatusValidacionObra",
    SUB_ELEMENTOS = 'catElementosObra',
    CAPAS = 'catTipoCapaObra',
    FUNCIONALIDADES = 'catFuncionalidades',
    UNIDADES_RESPONSABLES = 'catUnidadesResponsables'
}
